export default {
    upload: {
        browse: 'Parcourir...',
        fileTooBig: 'La taille totale ne peut pas dépasser {maximumSize}.',
        selectFile: 'Sélectionner le fichier...',
        selectOrDrag: 'Glisser-déposer vos fichiers ou cliquez pour selectionner les fichiers...',
    },
};
